import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from "vue-axios";
import VueRouter from 'vue-router'
import CreateWord from "@/views/CreateWord";
import MainView from "@/views/MainView";
import WordService from "@/services/WordService";
import FileUtils from "@/utils/fileUtils";

const fileUtils = new FileUtils();
const wordService = new WordService(fileUtils);

Vue.use(VueAxios, axios);
Vue.use(VueRouter);


Vue.config.productionTip = false
const routes = [
    {
        path: "/admin",
        component: CreateWord,
        beforeEnter: (to, from, next) => {
            if (process.env.NODE_ENV === 'production' && location.protocol !== 'https:') {
                location.replace(`https:${location.href.substring(location.protocol.length)}`);
            } else {
                next();
            }
        }
    },
    {path: "*", component: MainView},
]
const router = new VueRouter({routes});

new Vue({
    router,
    vuetify,
    wordService,
    fileUtils,
    render: h => h(App)
}).$mount('#app')
